<template>
  <div>
    <Form ref="searchForm" :label-width="70" :model="form">
      <FormItem label="搜索进程" style="width:100%;margin:10px 0 ;">
        <Input
          type="text"
          style="width:300px;"
          v-model="form.barId"
          placeholder=""
          search
          enter-button="搜索"
        />
      </FormItem>
    </Form>
    <div class="testCon pr">
      <Table
        stripe
        row-key="id"
        border
        height="454"
        :columns="columns"
        :data="newInterceptlog"
        ><template slot-scope="{ row, index }" slot="subid">
          <span v-if="row.subid == 10">模块名拦截</span>
          <span v-if="row.subid == 11">模块特征拦截</span>
          <span v-if="row.subid == 12">进程拦截</span>
        </template>
        <template slot-scope="{ row, index }" slot="name">
          <strong>{{ $MethodFn.getName(row.path) }}</strong>
        </template>
      </Table>
      <div class="scrollbar" ref="scrollbar">
        <div ref="inScrollbar" :style="{ height: scrollHeight }"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['data'],
  data() {
    return {
      newInterceptlog: [],
      scrollHeight: 0,
      scrollbarTop: '',
      size: 13,
      form: {
        barId: '',
      },
      columns: [
        {
          title: '时间',
          key: 'time',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
        {
          title: '类型',
          slot: 'subid',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
        {
          title: '进程ID',
          key: 'pid',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
        {
          title: '进程名',
          slot: 'name',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
        {
          title: '进程/模块路径',
          key: 'path',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
        {
          title: '文件路径',
          key: 'cmd',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
        {
          title: '命中特征',
          key: 'hash',
          sortable: true,
          align: 'center',
          tree: true,
          tooltip: true,
        },
      ],
      dataSource: [],
    }
  },
  watch: {
    data() {
      this.getData()
    },
  },
  mounted() {
    this.$refs.scrollbar.addEventListener(
      'scroll',
      (e) => {
        this.scrollbarTop = this.$refs.scrollbar.scrollTop
        this.getData()
      },
      false
    )
    this.getData()
  },
  methods: {
    getData() {
      this.newInterceptlog = []
      this.scrollHeight = this.data.length * 32 + 'px'
      let newData = [...this.data]
      let index = Number(this.scrollbarTop) / 32
      if (newData.length <= this.size) {
        this.newInterceptlog = newData.slice(0, this.size)
      } else {
        let len
        if (Number(parseInt(index)) + this.size > newData.length) {
          len = newData.length
        } else {
          len = Number(parseInt(index)) + this.size
        }
        this.newInterceptlog = newData.slice(Number(parseInt(index)), len)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.scrollbar {
  height: 454px;
  width: 30px;
  right: 0px;
  position: absolute;
  overflow: auto;
  top: 0;
}
</style>
